import { render } from "./ComboDefault.vue?vue&type=template&id=6be7f34a"
import script from "./ComboDefault.vue?vue&type=script&lang=js"
export * from "./ComboDefault.vue?vue&type=script&lang=js"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__